<div class="otp-popup">
  <div class="d-flex justify-content-center">
    <div class="otp">
      <div class="otp-container">
        <!-- <span class="title" *ngIf="!isRegister">Xác thực</span> -->
        <div class="otp-container_form">
          <div class="form-group container-title">
            <span>{{'Nhập mã xác nhận được gửi đến email của Team Lead'}} <br>
              {{'Vui lòng nhập mã xác nhận bên dưới'}}
            </span>
          </div>
          <div class="form-group">
            <input-number [maxLength]="6" [isInteger]="true" [isSeparate]="false"
                [(amount)]="otp" *ngIf="countdown != 0" [isTextAlignCenter]="true">
            </input-number>
            <span class="error-text text-center mt-3" *ngIf="isInvalidOTP && countdown != 0">
              {{errorText || 'OTP không hợp lệ. Vui lòng thử lại'}}</span>
          </div>
          <div class="form-group group-text">
            <span *ngIf="countdown !== 0" >{{'Mã OTP sẽ hết hạn trong vòng'}} <span class="required">{{countdown}}s</span></span>
            <span *ngIf="countdown === 0" class="required">Mã đã hết hạn</span>
            <a (click)="resendOTP()" prevent-multi-clicks class="udl">{{'Gửi lại mã'}}</a>
          </div>
          <div class="form-group">
            <button type="submit" class="btn common__btn common__btn--default w-100" [disabled]="!validate()"
              (click)="confirm()" prevent-multi-clicks>{{'Xác nhận'}}
            </button>
            <a class="button-close" (click)="dismiss()">{{'Hủy'}}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>